var React = require('react');

function Time (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M2 12C2 6.48 6.47 2 11.99 2C17.52 2 22 6.48 22 12C22 17.52 17.52 22 11.99 22C6.47 22 2 17.52 2 12ZM4 12C4 16.42 7.58 20 12 20C16.42 20 20 16.42 20 12C20 7.58 16.42 4 12 4C7.58 4 4 7.58 4 12ZM11 6.99994H12.5V12.2499L17 14.9199L16.25 16.1499L11 12.9999V6.99994Z","fill":"currentColor"}));
}

Time.defaultProps = {"viewBox":"0 0 24 24","fill":"none","style":{"color":"#39424A"}};

module.exports = Time;

Time.default = Time;
